import { Grid, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TIPOS_MENSAJES } from "../../Constants";

const AudioBubble = styled("div")(({ sent }) => ({
  backgroundColor: sent ? "#dcf8c6" : "#fff",
  padding: "8px",
  borderRadius: "7.5px",
  maxWidth: "330px",
  position: "relative",
  boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
  marginBottom: "10px",
}));

export default function Audio({ audioKey, tipos, times, fetchMediaUrl }) {
  const [audioUrl, setAudioUrl] = useState(null);
  const isSent = tipos === TIPOS_MENSAJES.enviado;

  useEffect(() => {
    if (audioKey) {
      fetchMediaUrl(audioKey, setAudioUrl, ".mp3");
    }
  }, [audioKey]);

  return (
    <Grid
      container
      justifyContent={isSent ? "flex-end" : "flex-start"}
      sx={{ padding: "0 5%" }}
    >
      <AudioBubble sent={isSent}>
        <audio controls style={{ width: "250px" }}>
          {audioUrl && <source src={audioUrl} type="audio/mpeg" />}
          Tu navegador no soporta el elemento de audio.
        </audio>
        <div style={{ fontSize: 11, color: "#888", marginTop: 4 }}>{times}</div>
      </AudioBubble>
    </Grid>
  );
}
